import { JsonPipe, NgClass, NgStyle }                                  from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';

const CLASS = (width: string) => {
  return {
    width: `${width}px`,
  }
}

@Component ({
              selector:        'loader',
              standalone:      true,
              changeDetection: ChangeDetectionStrategy.OnPush,
              styleUrls:       ['./loader.component.scss'],
              template:        `
                                 <div class="loader" [ngStyle]="style()">
                                   <svg class="circular" viewBox="25 25 50 50">
                                     <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2"
                                             stroke-miterlimit="10" />
                                   </svg>
                                 </div>
                               `,
              imports: [
                NgClass,
                JsonPipe,
                NgStyle,
              ],
            })
export class LoaderComponent {
  public width = input<string>('60');
  public style: Signal<any> = computed(() => CLASS(this.width()));


}
